/*
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 10:12:53
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-08-11 10:46:01
 */
const getters = {
  token: state => state.app.token,
  userInfo: state => state.app.userInfo,
  hostLabel: state => state.app.hostLabel,
  returnpath: state => state.app.returnpath,
  organList: state => state.app.organList,
  rootOrganAddress: state => state.app.rootOrganAddress,
  baseId: state => state.app.baseId,
  orgId: state => state.app.orgId,
  type: state => state.app.type,
  groupId: state => state.app.groupId,
  groupList: state => state.app.groupList,
  menuFlag: state => state.app.menuFlag,
  dayYm: state => state.app.dayYm,
  monthYm: state => state.app.monthYm,
  historyLength: state => state.app.historyLength,
}
export default getters